import { AuthContext } from "@/providers/AuthProvider";
import type { AuthContextType } from "@/types/providers/auth";

import { useContext } from "react";

export default function useAuth() {
  const context = useContext(AuthContext) as AuthContextType;
  if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return context;
}
